<template>
    <div>
        <audio-table ref="table" :url="indexUrl">
            <template v-slot:buttons>
                <button class="btn btn-purple" v-if="canCreate" @click="addAudio">
                    <i class="far fa-file"></i>
                </button>
            </template>
        </audio-table>
        <dialog-form-wrapper></dialog-form-wrapper>
    </div>
</template>

<script>
  import AudioTable from '../../components/audio/table';
  import eventBus from '../../event-bus';
  import DialogFormWrapper from './dialog-form-wrapper';

  export default {
    components: {
      AudioTable,
      DialogFormWrapper,
    },

    props: {
      indexUrl: String,
      createUrl: null,
      canCreate: {
        type: Boolean,
        default: false
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.table.refresh();
      },

      /**
       * @event show-add-audio-dialog
       */
      addAudio() {
        eventBus.$emit('show-add-audio-dialog', this.createUrl);
      },
    },

    created() {
      eventBus.$on('refresh-audio-table', this.refresh);
    },

    beforeDestroy() {
      eventBus.$off('refresh-audio-table', this.refresh);
    }
  }
</script>
